import { useIndexQuery } from 'api';
import type { FeatureFlags } from 'types/models/core_global_settings';

export const useFeatureFlag = (flag: keyof FeatureFlags) => {
  const { data, isLoading } = useIndexQuery('core/global_settings', undefined);

  return { isEnabled: !!data?.global_settings.feature_flags[flag], isLoading };
};
